const defaultState = {
  isCampaignActive: false,
  isHelpActive: false,
  url: "",
};

const ingFaqConditions = (state = defaultState, action) => {
  switch (action.type) {
    case "CHANGE_STATUS_OF_INGFAQ_CONDITIONS":
      return {
        isCampaignActive: action.isCampaignActive,
        isHelpActive: action.isHelpActive,
        url: action.url,
      };
    default:
      return state;
  }
};

export default ingFaqConditions;
